import { IRequest } from '@r1-frontend/shared/types/IRequest';

/**
 * @param salePackageId
 * @param withAuth
 * @link https://master.api-tariffs.sandbox.d2c.r-one.io/docs#/Tariffs/TariffsController_subscriptions
 */
const subscriptions = (salePackageId: number, withAuth = false): IRequest => ({
    uri: `v1/tariffs/${salePackageId}/subscriptions`,
    method: 'GET',

    withProvider: true,
    withAuth,
});

export default subscriptions;

export * from './dto/ResponseDto';
